var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.876A9.005 9.005 0 0 1 .055 1.999C-.005 1.448.448 1 1 1h16c.552 0 1.006.45.945.998A9.005 9.005 0 0 1 10.5 9.877v5.764a.5.5 0 0 1-.342.474l-2 .667a.5.5 0 0 1-.658-.475v-6.43Z"
  })));
};

export default SvgFilter;